var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 616,
    viewBox: "0 0 610 616",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 305,
    r: 305,
    fill: "#F1F2FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 305,
    r: 269,
    fill: "#E7E9FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.5,
    cy: 255.5,
    r: 81.5,
    fill: "#5A31FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 481.5C440 445.828 425.83 411.618 400.606 386.394C375.382 361.17 341.172 347 305.5 347C269.828 347 235.618 361.17 210.394 386.394C185.171 411.618 171 445.828 171 481.5L305.5 481.5H440Z",
    fill: "#5A31FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3f688e9df0ca940933925daa438e15ca.svg";
export { ForwardRef as ReactComponent };